import { Application } from '@hotwired/stimulus';
import { Injector, NgModule } from '@angular/core';
import TriggersFormController from './controllers/triggers-form.controller';
import SymbolFieldController from './controllers/symbol-field.controller';
import { apply as applyCustomFieldsControllerPatch } from './patches/custom-fields.controller.patch'
import CustomActionsFormController from './controllers/custom-actions-form.controller';

applyCustomFieldsControllerPatch();

declare global {
  interface Window {
    Stimulus:Application;
  }
}

@NgModule({
  providers: [],
})
export class PluginModule {
  constructor(injector:Injector) {
    window.Stimulus.register('triggers-form', TriggersFormController);
    window.Stimulus.register('symbol-field', SymbolFieldController);
    window.Stimulus.register('custom-actions-form', CustomActionsFormController);
  }
}
